export default __webpack_public_path__ + "static/media/result_samplefile.e60a3c26.xlsx";